import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

import Login     from './pages/Login/Login';
import TenantApp from './tenant/TenantApp';
import PolicyPage from "./pages/Policy/PolicyPage";

export default function App() {
    return (
        <>
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    {/* Tela inicial: seleção do tenant */}
                    <Route path="/" element={<Login />} />

                    {/* Conteúdo autenticado por tenant */}
                    <Route path="/:tenant/*" element={<TenantApp />} />
                    <Route path="/policy" element={<PolicyPage />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}
